import { render, staticRenderFns } from "./RouteTransitionOverlay.vue?vue&type=template&id=604bb9fe&scoped=true"
import script from "./RouteTransitionOverlay.vue?vue&type=script&lang=js"
export * from "./RouteTransitionOverlay.vue?vue&type=script&lang=js"
import style0 from "./RouteTransitionOverlay.vue?vue&type=style&index=0&id=604bb9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604bb9fe",
  null
  
)

export default component.exports